import { render, staticRenderFns } from "./PrivacyNotice.vue?vue&type=template&id=6a752bd5&scoped=true"
var script = {}
import style0 from "./PrivacyNotice.vue?vue&type=style&index=0&id=6a752bd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a752bd5",
  null
  
)

export default component.exports